/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
import Swiper from "vux/src/components/swiper/swiper.vue";
import CopyRight from 'CopyRight';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { GETTER_CLINICOBJ, ACTION_CLINICOBJ } from '@/store/mutation_types';
import { GetAttentReply } from '@/api/miniClinic';
export default {
  data: function data() {
    return {
      attentReply: {}
    };
  },
  components: {
    CopyRight: CopyRight
  },
  created: function created() {},
  computed: _objectSpread({}, mapGetters({})),
  mounted: function mounted() {
    this.fetchClinicInfo();
  },
  methods: _objectSpread(_objectSpread({}, mapActions({})), {}, {
    addImg: function addImg(imgUrl) {
      var obj = {
        url: 'javascript:',
        img: imgUrl,
        title: ''
      };
      this.imgArray.push(obj);
    },

    /** 初始化诊所信息 */
    fetchClinicInfo: function fetchClinicInfo() {
      var _this = this;

      GetAttentReply().then(function (data) {
        if (data.DIGEST) {
          window.title = data.DIGEST;
        }

        _this.attentReply = data;
      });
    }
  })
};